import React from 'react';
import { Formik } from 'formik';
import { Box, InputAdornment } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { InputField } from '../../../../components/forms/fields';
import FormWrapper from '../../../../components/forms/FormWrapper';
import { DiscountFormValues, DiscountFormProps } from './types';
import { discountValidationSchema } from './validation';

const DiscountForm = ({
    submitText,
    onSubmit,
    initialValues,
}: DiscountFormProps) => {
    const { t } = useTranslation();
    const defaultValues = {
        name: '',
        description: '',
        rate: 0.0,
    };


    return (
        <Formik
            initialValues={{ ...defaultValues, ...initialValues }}
            validationSchema={discountValidationSchema}
            onSubmit={onSubmit}
        >
            {formikProps => (
                <FormWrapper submitText={submitText} isSubmitting={formikProps.isSubmitting}>
                    <Box my={2} display="flex" flexDirection="column">
                        <InputField<DiscountFormValues>
                            name="name"
                            label={t('Name')}
                            formikProps={formikProps}
                            required
                        />
                        <InputField<DiscountFormValues>
                            name="description"
                            label={t('Description')}
                            formikProps={formikProps}
                        />
                        <InputField<DiscountFormValues>
                            name="rate"
                            type='number'
                            inputMode='decimal'
                            label={t('Discount')}
                            formikProps={formikProps}
                            required
                            endAdornment={<InputAdornment position="end">%</InputAdornment>}
                        />
                    </Box>
                </FormWrapper>
          )}
        </Formik>
    );
};

export default DiscountForm;
